import { Roles } from 'UI/constants/roles';

export const INTERVIEW_TYPE_IDS = {
  FaceToFace: 1,
  RemoteVideo: 2
};

export const SENDOUT_SUPER_USER_ROLES = [
  Roles.Operations,
  Roles.ProductionDirector,
  Roles.Leadership,
  Roles.DataCoordinator
];

export const COLLABORATOR_SCOPE = {
  Any: 'any',
  PairedToAccountable: 'pairedToAccountable'
};
